import { useEffect, useRef } from 'react';

const REFRESH_INTERVALS = {
    home: {
        data: 5 * 60 * 1000,       // Headlines + Report + AI Events
        events: 5 * 60 * 1000,     // Market Events
    },
    feed: {
        feeds: 5 * 60 * 1000,      // Feed list
        topData: 10 * 60 * 1000,   // AI summary + tech news + HN
    },
    workbench: {
        market: 2 * 60 * 1000,     // Quotes + Sparklines
        events: 5 * 60 * 1000,     // Events + Pulse
        discovery: 15 * 60 * 1000, // ARK + Investors
    },
    aiFuture: {
        stocks: 3 * 60 * 1000,     // AI Stocks
        events: 10 * 60 * 1000,    // AI Events + Summary
    },
};

export function useAutoRefresh(callback, intervalMs) {
    const callbackRef = useRef(callback);
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!intervalMs || intervalMs <= 0) return;
        const id = setInterval(() => callbackRef.current(), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);
}

export default REFRESH_INTERVALS;
